export default "__VITE_ASSET__BQdTEGQ0__"